import type { SystemPresetCreate } from '@/entities/system-presets';
import { pickPresetSnapshot } from './store';
import type { TableSettings } from './types';

/** Личный пресет таблицы, который делают системным, — то, что из него переходит в системный */
type PersonalPresetToSystem = {
  name: string;
  /** Запись личного пресета в настройках пользователя: снимок вида вместе со служебными полями */
  settings: TableSettings;
  /** Личный пресет закреплён отдельным пунктом левого меню */
  pinned: boolean;
};

/**
 * Запрос создания системного пресета на месте личного: те же название и вид, а закрепление
 * переносится. Перевод в системные меняет то, кому принадлежит пресет, а не его место в меню:
 * закрепляет системный пресет тот же обладатель разрешения, что делает его системным, поэтому
 * его распоряжение о месте пресета переходит на системный и действует для всех.
 */
export const buildSystemPresetFromPersonal = (
  tableName: string,
  preset: PersonalPresetToSystem,
): SystemPresetCreate => ({
  tableName,
  name: preset.name,
  settings: pickPresetSnapshot(preset.settings),
  isPinned: preset.pinned,
});
